
import React from 'react';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'helpers/ModuleHelper';
import * as actions from 'store/actions';
import * as ConfigTypes from 'config/ConfigTypes';
import Form from 'react-bootstrap/Form';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppButton from "components/Button/Button";
import { getMetaConfig, getDropdownData, getAutoDdData } from "helpers/ConfigHelper";
import AppDropdown from 'components/Dropdown/Dropdown';
import DropdownWithInput from 'components/UI/DropdownWithInput/DropdownWithInput';
import WorkList from 'components/Work/WorkList/WorkList';
import ClipList from 'components/Clip/ClipList/ClipList';
import Spinner from 'layouts/UIElements/Spinner/Spinner';
import MiniPagination from 'components/MiniPagination/MiniPagination';
import { getSearchFields, getSortField } from "helpers/FieldHelper";
import CheckBox from "components/CheckBox/CheckBox";
import { isHome } from 'helpers/AppHelper';

import "./SearchFilter.scss"

const SearchFilter = observer(
    class SearchFilter extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                data: [],
                viewMode: ConfigTypes.SEARCH_FILTER,
                form: {},
                tabClasses: {},
                clStyles: { [ConfigTypes.LIST]: ConfigTypes.BTN_ACTIVE },
                tabCurrentPage: 0,
                tabTotalPages: 0,
                isListView: true,
                searchFullText: '',
                cssStyle: { display: 'none' }
            }
        }

        isActiveTab = ({ item }) => {
            const { currentTab }
                = this.props.mediaObjects;
            if ((currentTab && currentTab.name === item.name) || (!currentTab && item.active)) {
                return true;
            }
            return false;
        }

        initFilter = ({ item }) => {
            const { searchFilterObj }
                = this.props.mediaObjects;
            if (searchFilterObj[item.part]) this.setState({ [item.part]: searchFilterObj[item.part] });
            else this.setState({ [item.part]: {} });
        }

        initData = () => {
            const { workTotalPages, totalPages, currentPage, workCurrentPage, workKeyword, objectKeyword, currentTab }
                = this.props.mediaObjects;
            let workSearch = false;
            let tabCurrentPage = currentPage || 1;
            let tabTotalPages = totalPages || 1;
            let searchFullText = objectKeyword || '';

            ConfigTypes.SEARCHFILTER_TABS.forEach(item => {
                let data = getMetaConfig({ viewMode: this.state.viewMode, props: this.props, configName: item.configName });
                if (data && data.length) this.setState({ [`${item.part}_data`]: data, [`${item.part}_searchSortCurrent`]: data[0] });
                if (this.isActiveTab({ item })) {
                    if (item.name == ConfigTypes.TAB_WORK) {
                        workSearch = true;
                        searchFullText = workKeyword;
                        if (workCurrentPage) tabCurrentPage = workCurrentPage;
                        if (workTotalPages) tabTotalPages = workTotalPages;
                    }
                    if (!currentTab) this.props.updateMediaObjects({ currentTab: item });
                    this.setState({
                        data: data, workSearch, tabCurrentPage: tabCurrentPage, tabTotalPages: tabTotalPages, tab: item.name,
                        searchFullText, resultText: searchFullText, tabClasses: { [item.name]: 'searchfilter-active' }
                    }, () => this.checkTabPages());
                }
                this.initFilter({ item });
            })
        }

        updateResults = ({ tabName }) => {
            const { workTotalItems, totalItems } = this.props.mediaObjects;
            switch (tabName) {
                case ConfigTypes.TAB_WORK:
                    this.setState({ [`${tabName}Results`]: workTotalItems });
                    break;
                case ConfigTypes.TAB_OBJ:
                    this.setState({ [`${tabName}Results`]: totalItems });
                    break;
                default:
                    break;
            }
        }

        startNewSearch = () => {
            window.location.reload();
        };

        onFormChange = (item) => (e) => {
            const { value } = e.target;
            this.setState({ form: { ...this.state.form, [item.field]: value } })
        }

        getCollectObj = () => {
            let vMode = ConfigTypes.SEARCH_FILTER;
            let data = getMetaConfig({ viewMode: vMode, props: this.props, configName: ConfigTypes.OBJECT });
            let autoObj;
            if (data && data.length) {
                autoObj = data.find(item => {
                    let type = item[`${vMode}type`];
                    if (type && type.isAutoDd && type.path === ConfigTypes.COLLECTION_PATH) {
                        return item
                    }
                    return null;
                });
            }
            return autoObj;
        }

        startAuto = ({ fields, part }) => {
            const { collectionId } = this.props.mediaObjects;
            let vMode = ConfigTypes.SEARCH_FILTER;
            let st = `${vMode}searchtype`;
            let autoObj = this.getCollectObj();
            let type = autoObj[`${vMode}type`];
            let ddData = getAutoDdData({
                item: autoObj, type,
                options: this.props.mediaObjects[type.what]
            });
            if (autoObj) fields.push({ field: autoObj.field, type: autoObj[`${st}`], value: collectionId });
            let ddCur = ddData.find(item => item.value === collectionId);
            if (ddCur) {
                let fi = autoObj.field;
                this.setState({
                    [`${part.name}`]: {
                        ...this.state[`${part.name}`], [`${fi}`]: ddCur.intl,
                        [`${fi}_current`]: ddCur, [`${fi}_type`]: autoObj[`${st}`]
                    }
                });
            }
            return fields;
        }

        checkFields = ({ fields, part, isAuto }) => {
            if (this.state[part.name]) {
                for (let i in this.state[part.name]) {
                    if (!i.includes('_type') && !i.includes('_current')) {
                        let type = ConfigTypes.DEFAULT_SEARCH_TYPE;
                        if (this.state[part.name][`${i}_type`]) type = this.state[part.name][`${i}_type`];
                        fields.push({ field: i, type: type, value: this.state[part.name][i] });
                    }
                }
            }
            if (isAuto) fields = this.startAuto({ fields, part });
            let sortField = getSortField(this.state[`${part.name}_searchSortCurrent`], this.state.sort);
            if (sortField && this.state.sort) fields.push(sortField);
            return fields;
        }

        searchByFieldsAndFullTxt = ({ showAll = false, restart = false, isAuto = false }) => {
            const { portalSearchWorkMain, portalSearchRental } = this.props.mediaObjects;
            let workSearch;
            let fields = [];
            let viewMode = ConfigTypes.LIST;
            if (this.state.viewMode == ConfigTypes.GRID) viewMode = ConfigTypes.GRID;
            let part = this.getCurrentPart();
            let searchFullText = this.state.searchFullText;
            fields = this.checkFields({ fields, part, isAuto });
            let updated = { viewMode, workSearch };
            if (this.state.tab === ConfigTypes.TAB_WORK) {
                if (portalSearchWorkMain) fields.push(portalSearchWorkMain);
                if (portalSearchRental) fields.push(portalSearchRental);
                let searchParams = { fields, showAll, keyword: searchFullText, restart };
                this.props.searchWorks(searchParams);
                updated.workFields = fields;
                updated.workSearch = true;
                if (restart) updated.workCurrentPage = 1;

            }
            if (this.state.tab === ConfigTypes.TAB_OBJ) {
                this.props.searchObjects({ keyword: searchFullText, fields, showAll, restart });
                updated.objectFields = fields;
                updated.workSearch = false;
                if (restart) updated.currentPage = 1;
            }
            updated.workKeyword = searchFullText;
            updated.objectKeyword = searchFullText;
            this.setState({ viewMode, resultText: searchFullText });
            this.props.updateMediaObjects(updated);
        }

        onUseFilter = (restart = true) => {
            const { searchFilterObj } = this.props.mediaObjects;
            this.searchByFieldsAndFullTxt({ restart });
            let part = this.getCurrentPart(this.state.tab.name);
            let updatedObj = { ...searchFilterObj, [part.name]: this.state[part.name] };
            this.props.updateMediaObjects({ searchFilterObj: updatedObj });
            if (!isHome()) this.props.router.navigate("/");
        }

        onFullTextChange = (e) => {
            const { value, name } = e.target;
            this.setState({ searchFullText: value });
        }

        onResetFilter = () => {
            const { portalSearchRental } = this.props.mediaObjects;
            let fields = [];
            let updated = { portalSearchWorkMain: null };
            updated.portalCurrentDDItem = ConfigTypes.HOME_SEARCH_DD_ITEMS.find(item => item.active);
            if (this.state.tab === ConfigTypes.TAB_WORK) {
                //if (portalWorkMain) fields.push(portalWorkMain);
                //if (portalSearchRental) fields.push(portalSearchRental);
                let searchParams = { fields, keyword: '', restart: true };
                this.props.searchWorks(searchParams);
                // updated.workKeyword = '';
                updated.portalSearchRental = false;
                updated.workFields = fields;
                updated.workCurrentPage = 1;
            }
            if (this.state.tab === ConfigTypes.TAB_OBJ) {
                this.props.searchObjects({ keyword: '', fields, restart: true });
                // updated.objectKeyword = '';
                updated.objectFields = fields;
                updated.currentPage = 1;
            }
            updated.workKeyword = '';
            updated.objectKeyword = '';
            this.props.updateMediaObjects(updated);
            let part = this.getCurrentPart(this.state.tab.name);
            this.setState({ [part.name]: {}, searchFullText: '', resultText: '' });
            if (!isHome()) this.props.router.navigate("/");
        }

        showAll = () => {
            this.searchByFieldsAndFullTxt({ showAll: true });
        }

        getCurrentPart = (currentTab = false) => {
            let part = {};
            let tab;
            tab = this.state.tab
            if (currentTab) tab = currentTab;
            if (tab === ConfigTypes.TAB_WORK) part.name = ConfigTypes.PART_WORK;
            if (tab === ConfigTypes.TAB_OBJ) part.name = ConfigTypes.PART_OBJ;
            return part;
        }

        onTabClick = (tab, isAuto = false) => () => {
            if (tab && tab.name) {
                let data = [];
                let workSearch = false;
                let part = this.getCurrentPart(tab.name);
                if (this.state[`${part.name}_data`]) {
                    data = this.state[`${part.name}_data`];
                }
                if (tab.name === ConfigTypes.TAB_WORK) workSearch = true;
                let searchFullText = this.getTabFullText({ tab });
                this.setState({
                    tab: tab.name, workSearch, searchFullText,
                    loading: true, tabClasses: { [tab.name]: 'searchfilter-active' }
                }, () => {
                    this.setState({ data: data, loading: false });
                    this.searchByFieldsAndFullTxt({ isAuto });
                });
                this.props.updateMediaObjects({ currentTab: tab });
            }
        }

        getTabFullText = ({ tab }) => {
            const { workKeyword, objectKeyword } = this.props.mediaObjects;
            let searchFullText = objectKeyword || '';
            if (tab && tab.name) {
                if (tab.name === ConfigTypes.TAB_WORK) {
                    searchFullText = workKeyword;
                }
            }
            return searchFullText;
        }

        getResultsHeading = () => {
            const { portalCurrentDDItem } = this.props.mediaObjects;
            let heading = this.props.intl.formatMessage({ id: "searchfilter.searchresults" });
            let ddItem;
            if (portalCurrentDDItem && portalCurrentDDItem.intl) {
                ddItem = this.props.intl.formatMessage({ id: portalCurrentDDItem.intl });
            }
            return (
                <div>
                    {heading} <span className="searchfilter-redbold">
                        {this.state.resultText ? this.state.resultText : `" "`}
                    </span>
                    {` (in "${ddItem}" gesucht)`}
                </div>
            )
        }

        showResults = () => {
            let intlId = "searchfilter.works";
            let results, text = "";
            if (this.state.tab === ConfigTypes.TAB_OBJ) intlId = "searchfilter.objects";
            if (this.state[`${this.state.tab}Results`]) results = this.state[`${this.state.tab}Results`];
            if (results) {
                text = " " + this.props.intl.formatMessage({ id: intlId });
                text += " " + this.props.intl.formatMessage({ id: "searchfilter.found" });
            }
            return (
                <div>
                    <span className="searchfilter-redbold">
                        {results && results}
                    </span>
                    {text}
                </div>
            )
        }

        showTabBtn = () => {
            return (
                <div className="searchfilter-tab-top">
                    {
                        ConfigTypes.SEARCHFILTER_TABS.map((tab, i) => {
                            return (
                                <div className={`searchfilter-tab-btn ${this.state.tabClasses[tab.name]}`}
                                    onClick={this.onTabClick(tab)} key={`searchfilter_tabbtn${i}`}
                                    style={tab.checkDisplay && this.state.cssStyle} >
                                    {`${this.props.intl.formatMessage({ id: tab.intl })}`}
                                </div>
                            )
                        })
                    }
                </div>
            )
        }

        showListViewHeader = () => {
            const { viewMode } = this.props.mediaObjects;
            let configName = ConfigTypes.OBJECT;
            let htmlClass = "searchfilter-header-box-list-objects"
            if (this.state.tab === ConfigTypes.TAB_WORK) {
                configName = ConfigTypes.WORK;
                htmlClass = "searchfilter-header-box-list";
            }
            let showFields = getMetaConfig({
                viewMode: viewMode,
                props: this.props,
                configName: configName
            });
            return (
                <div className={htmlClass}>
                    {showFields && showFields.map((item, i) => {
                        return (<div className="searchfilter-header-item-list" key={`searchfilter_listview${i}`}>
                            {item.intl && this.props.intl.formatMessage({ id: item.intl })}
                        </div>)
                    })}
                </div>
            )
        }

        toggleViewMode = (view) => () => {
            this.setState({
                viewMode: view,
                clStyles: { [view]: ConfigTypes.BTN_ACTIVE }
            });
            if (view === ConfigTypes.LIST) this.setState({ isListView: true });
            else this.setState({ isListView: false });
            this.props.updateMediaObjects({ viewMode: view });
        }

        showRightSide = () => {
            return (
                <div>
                    <div className="searchfilter-top">
                        <div className="searchfilter-tab">
                            {this.showTabBtn()}
                        </div>
                        <div className="searchfilter-topright">
                            {/* <AppPagination /> */}
                            <div className="searchfilter-count">
                                {`${this.state.tabCurrentPage}/${this.state.tabTotalPages}`}
                            </div>
                            <div className="searchfilter-dd-wrapper">{this.showSortDD()}</div>
                            <div className="searchfilter-listbtn-wrapper">
                                {ConfigTypes.VIEW_ICON_BTNS.map((item, i) => (
                                    <div className={`searchfilter-listbtn  ${this.state.clStyles[item.name]}`}
                                        key={`searchfilterClipListIcon${i}`}
                                        onClick={this.toggleViewMode(item.name)}>
                                        <FontAwesomeIcon icon={item.icon} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="searchfilter-results">
                        {/* {this.getResultsHeading()} */}
                        {this.showResults()}
                    </div>
                    <div className="searchfilter-body">
                        {this.state.isListView && this.showListViewHeader()}
                        <div className="searchfilter-listcontent">
                            {this.state.tab === ConfigTypes.TAB_WORK ? <WorkList /> : <ClipList />}
                        </div>
                    </div>
                    <div className="searchfilter-footer">
                        <div></div>
                        <div className="searchfilter-pagination">
                            {/* <div className="searchfilter-showall" onClick={this.showAll}>
                                {this.props.intl.formatMessage({ id: "searchfilter.showall" })}
                            </div> */}
                            {!this.state.loading && <MiniPagination workSearch={this.state.workSearch} showAll={true} />}
                        </div>
                    </div>
                </div>
            )
        }

        showFilterBtnActions = () => {
            return ConfigTypes.SEARCHFILTER_ACTIONS.map((item, i) => {
                return (
                    <AppButton key={`searchfilterActions${i}`} className="searchfilter-btn-filter"
                        btnTxt={this.props.intl.formatMessage({ id: item.intl })}
                        onClick={this[item.onClick]} icon={item.icon} />
                )
            })
        }

        onChangeHandler = ({ item, part }) => (e) => {
            const { value } = e.target;
            this.setState({
                [part.name]: {
                    ...this.state[part.name],
                    [item.field]: value,
                    [`${item.field}_type`]: item[`${this.state.viewMode}searchtype`]
                }
            });
        };

        onDDClick = ({ item, part }) => (option) => {
            this.setState({
                [part.name]: {
                    ...this.state[part.name],
                    [item.field]: option.name,
                    [`${item.field}_current`]: option,
                    [`${item.field}_type`]: item[`${ConfigTypes.SEARCH_FILTER}searchtype`]
                }
            });
        }

        getDDData = ({ item, type }) => {
            let data = [];
            if (type && type.isAutoDd) {
                if (type.what && this.props.mediaObjects[type.what]) {
                    data = getAutoDdData({ item, type, options: this.props.mediaObjects[type.what] });
                }
            }
            else data = getDropdownData({ item, viewMode: ConfigTypes.SEARCH_FILTER });
            return data;
        }

        handleCBox = ({ e, item, part, type }) => {
            let value = '';
            if (e.target.checked && type && type.value) value = type.value;
            let updated = { ...this.state[part.name] };
            if (value) updated[item.field] = value;
            else delete updated[item.field];
            this.setState({ [part.name]: updated });
        }

        showDD = ({ part, item, i, type }) => {
            let groupClass = "searchfilter-formcontrol";
            if (part.groupClass) groupClass = "searchfilter-formgroup";
            let data = this.getDDData({ item, type });
            if (data)
                return (
                    <Form.Group className={groupClass}
                        key={`searchfilterCatalog${i}`} onKeyUp={this.onKeyUpFeld}
                        controlId="exampleForm.ControlInput1" >
                        <div className="searchfilter-dd-box">
                            <AppDropdown
                                data={data} current={this.state[part.name][`${item.field}_current`]}
                                onDDClick={this.onDDClick({ item, part })} />
                        </div>
                    </Form.Group>
                );
            return <div></div>
        }

        showCBox = ({ part, item, i, type }) => {
            return (
                <CheckBox key={`searchfilterCatalog${i}`} onCbChange={(e) => this.handleCBox({ e, item, part, type })}
                    isChecked={this.state[part.name][item.field] ? this.state[part.name][item.field] : false}
                    label={this.props.intl.formatMessage({ id: item.intl })} />
            )
        }

        showDDWithInput = ({ part, item, i, type }) => {
            let groupClass = "searchfilter-formcontrol";
            if (part.groupClass) groupClass = "searchfilter-formgroup";
            let data = this.getDDData({ item, type });
            if (data)
                return (
                    <Form.Group className={groupClass}
                        key={`searchfilterCatalog${i}`} onKeyUp={this.onKeyUpFeld}
                        controlId="exampleForm.ControlInput1" >
                        <div className="searchfilter-dd-box">
                            <DropdownWithInput
                                data={data} current={this.state[part.name][`${item.field}_current`]}
                                onDDClick={this.onDDClick({ item, part })} />
                        </div>
                    </Form.Group>
                );
            return <div></div>
        }


        onKeyUpFeld = (e) => {
            if (e.key === ConfigTypes.ENTER) {
                this.onUseFilter();
            }
        }

        showInput = ({ part, item, i }) => {
            let intl = item.intl;
            if (item[`${ConfigTypes.SEARCH_FILTER}intl`]) intl = item[`${ConfigTypes.SEARCH_FILTER}intl`];
            return (
                <Form.Group className="searchfilter-formcontrol"
                    key={`searchfilter${i}`} onKeyUp={this.onKeyUpFeld}
                    controlId="exampleForm.ControlInput1">
                    {/* <Form.Label>{this.props.intl.formatMessage({ id: item.intl })}</Form.Label> */}
                    <Form.Control type={item.type}
                        onChange={this.onChangeHandler({ item, part })}
                        value={this.state[part.name][item.field] ? this.state[part.name][item.field] : ""}
                        placeholder={this.props.intl.formatMessage({ id: intl })} />
                </Form.Group>
            );
        }

        showFilterComponents = () => {
            let part = this.getCurrentPart();
            return this.state.data && this.state.data.map((item, i) => {
                let type = item[`${ConfigTypes.SEARCH_FILTER}type`] || '';
                if (type && type.isDDInput) return this.showDDWithInput({ part, item, i, type });
                if (type && (type == ConfigTypes.DROPDOWN || type.isAutoDd)) {
                    return this.showDD({ part, item, i, type });
                }
                if (type && type.isCBox) {
                    return this.showCBox({ part, item, i, type });
                }

                return this.showInput({ part, item, i });
            });
        }

        showLeftSide = () => {
            return (
                <div>
                    {/* <AppButton icon={faSearch} className="searchfilter-btn-search"
                        btnTxt={this.props.intl.formatMessage({ id: "searchfilter.button.search" })}
                        onClick={this.startNewSearch} /> */}
                    <div className="searchfilter-filterbox" onKeyUp={this.onKeyUpFeld}>
                        <input className="form-control" value={this.state.searchFullText}
                            onChange={this.onFullTextChange} type="text"
                            placeholder={this.props.intl.formatMessage({ id: "searchfilter.filter.search" })} />
                    </div>
                    <div>
                        {this.showRental()}
                    </div>
                    {this.showFilterComponents()}
                    {this.showFilterBtnActions()}
                </div>
            )
        }

        checkTabPages = () => {
            const { workTotalPages, totalPages, currentPage, workCurrentPage } = this.props.mediaObjects;
            let isTabWork = this.state.tab === ConfigTypes.TAB_WORK ? true : false;
            this.setState({ loading: true });
            let tabCurrentPage = currentPage;
            let tabTotalPages = totalPages;
            if (isTabWork) {
                tabCurrentPage = workCurrentPage;
                tabTotalPages = workTotalPages;
            }

            this.initDropdown();
            this.updateResults({ tabName: this.state.tab });
            this.setState({ tabCurrentPage, tabTotalPages },
                () => this.setState({ loading: false }));
        }

        //SORT BEGIN

        initDropdown = () => {
            let configName = ConfigTypes.OBJECT;
            let part = this.getCurrentPart();
            if (this.state.tab === ConfigTypes.TAB_WORK) configName = ConfigTypes.WORK;
            const data = getMetaConfig({ viewMode: ConfigTypes.SEARCH_FILTER, props: this.props, configName });
            if (data && data.length) {
                this.setState({ data: data, [`${part.name}_searchSortCurrent`]: data[0] });
            }
        }

        onSearchSortClick = (item) => {
            let part = this.getCurrentPart();
            this.setState({ [`${part.name}_searchSortCurrent`]: item });
            this.props.updateMediaObjects({ [`${part.name}_searchSortCurrent`]: item });
        }

        onSortArrowClick = (sort) => () => {
            this.setState({ sort: sort }, () => this.onUseFilter(false));
        }

        showSortDD = () => {
            let part = this.getCurrentPart();
            if (this.state.data && this.state.data.length)
                return (
                    <div className="searchfilter-dd-box">
                        <AppDropdown
                            data={this.state.data} current={this.state[`${part.name}_searchSortCurrent`]}
                            onDDClick={this.onSearchSortClick} />
                        <div className="searchfilter-dd-sorticons">
                            {ConfigTypes.SORT_ICON_BTNS.map((item, i) => (
                                <span key={`searchfilterSortIcon${i}`}>
                                    <FontAwesomeIcon icon={item.icon}
                                        onClick={this.onSortArrowClick(item.name)} />
                                </span>))}
                        </div>
                    </div>);
        }
        //SORT END

        onRentalFilm = (e) => {
            let portalSearchRental = ConfigTypes.RENTALOBJ;
            if (!e.target.checked) portalSearchRental = false;
            this.props.updateMediaObjects({ portalSearchRental });
        }

        showRental = () => {
            if (this.state.tab && this.state.tab === ConfigTypes.TAB_WORK) {
                const { portalSearchRental } = this.props.mediaObjects;
                return (
                    <CheckBox onCbChange={this.onRentalFilm} isChecked={portalSearchRental}
                        label={this.props.intl.formatMessage({ id: "mainpage.rentalfilm" })} />
                )
            }
        }

        checkTabDisplay = () => {
            const { portalSearchRental } = this.props.mediaObjects;
            this.setState({ cssStyle: { display: portalSearchRental ? ConfigTypes.NONE : ConfigTypes.FLEX } });
        }

        searchAutoCollection = () => {
            const { collectionId } = this.props.mediaObjects;
            if (collectionId) {
                console.log("LOGS: searchAutoCollection collectionId", collectionId);
                this.onTabClick(ConfigTypes.TAB_OBJ_ITEM, true)();
            }

        }

        componentDidUpdate(prev) {
            const { workTotalItems, totalItems, currentTab, currentPage,
                workCurrentPage, totalPages, workTotalPages, portalSearchRental, collectionId }
                = this.props.mediaObjects;
            if (prev.mediaObjects.totalItems != totalItems) {
                this.updateResults({ tabName: ConfigTypes.TAB_OBJ });
                this.setState({ tabTotalItems: totalItems });
                this.checkTabPages();
            }

            if (prev.mediaObjects.workTotalItems != workTotalItems) {
                this.updateResults({ tabName: ConfigTypes.TAB_WORK });
                this.setState({ tabTotalItems: workTotalItems });
                this.checkTabPages();
            }

            if ((prev.mediaObjects.currentTab != currentTab)
                || (prev.mediaObjects.currentPage != currentPage)
                || (prev.mediaObjects.totalPages != totalPages)
                || (prev.mediaObjects.workTotalPages != workTotalPages)
                || (prev.mediaObjects.workCurrentPage != workCurrentPage)
            ) {
                this.checkTabPages();
            }

            if (prev.mediaObjects.portalSearchRental != portalSearchRental) {
                this.checkTabDisplay();
            }

            if (prev.mediaObjects.collectionId != collectionId) {
                this.searchAutoCollection();
            }
        }

        componentWillUnmount() {
            if (!ConfigTypes.REFRESH_HOME) {
                if (ConfigTypes.REFRESH_FILTER) {
                    this.props.updateMediaObjects({ searchFilterObj: {} });
                }
            }
        }

        componentDidMount() {
            this.initData();
            this.checkTabDisplay();
            this.props.getFeDDOptions(ConfigTypes.COLLECTION);
        }

        render() {
            return (
                <div className="searchfilter">
                    <div className="searchfilter-wrapper">
                        <div className="searchfilter-left">
                            <Form>{this.showLeftSide()}</Form>
                        </div>
                        <div className="searchfilter-right">
                            {this.showRightSide()}
                        </div>
                    </div>
                    {this.props.loading && (
                        <div className="searchfilter-overlay">
                            <Spinner />
                        </div>)}
                </div>)
        }
    }
);

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    loading: state.media.mediaObjects.loading,
    configObjects: state.config.configObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    searchObjects: (data) => dispatch(actions.searchObjects(data)),
    searchWorks: (data) => dispatch(actions.searchWorks(data)),
    getFeDDOptions: (data) => dispatch(actions.getFeDDOptions(data))
});

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(SearchFilter))));

